import { render, staticRenderFns } from "./render-billing-status-column-value.vue?vue&type=template&id=a628c110"
import script from "./render-billing-status-column-value.vue?vue&type=script&lang=js"
export * from "./render-billing-status-column-value.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/samuelscn/Área de Trabalho/veins/veins-api/VeinsEnergia-api/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a628c110')) {
      api.createRecord('a628c110', component.options)
    } else {
      api.reload('a628c110', component.options)
    }
    module.hot.accept("./render-billing-status-column-value.vue?vue&type=template&id=a628c110", function () {
      api.rerender('a628c110', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "assets/ui/render/render-billing-status-column-value.vue"
export default component.exports